<div #staffHeader fxLayout="row" class="staff-title">
  <div fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="grow">
    <!-- user-location -->
    <div *ngIf="locations" class="nav-links">
      <i
        class="fa fa-map-marker"
        aria-hidden="true"
        style="font-size: 1em; margin-left: 15px; margin-right: 5px"
      ></i>
      <select
        #select
        title="Select Home Location"
        [(ngModel)]="selectedLocation"
        (ngModelChange)="updateLocation($event)"
      >
        <option *ngFor="let loc of locations" [ngValue]="loc">
          {{ loc.name }}
        </option>
      </select>
    </div>

    <!-- Staff Breadcrumb -->
    <div class="bread-links">
      <a tabindex="0" (agInteract)="openStaffMenu()">
        <i class="fa fa-link" aria-hidden="true"></i
        ><span> {{ pageLabel ?? fullLabel ?? 'Staff Menu' }}</span>
      </a>
    </div>

    <div class="bread-links">
      <ng-container
        *ngFor="let quickItem of quickMenuService.quickMenuItems$ | async; let i = index"
      >
        <a
          class="quicklinks-color"
          tabindex="0"
          [matTooltip]="quickItem | quickLinkLabel"
          (agInteract)="openQuickLink(quickItem)"
        >
          <span class="quick-hotkey badge badge-pill">{{ i === 9 ? '0' : i + 1 }}</span>
        </a>
      </ng-container>
      <a *ngIf="staffHistory?.length" tabindex="0" (agInteract)="openLastStaffHistory()"
        ><span class="quick-hotkey badge badge-pill">L</span>
      </a>
    </div>
  </div>
  <div fxLayoutAlign="end center">
    <!-- close iframe module -->
    <div title="Close" class="close-staff">
      <i
        id="staffClose"
        class="fa fa-lg fa-times-circle"
        aria-hidden="true"
        tabindex="0"
        (agInteract)="closeStaffModule()"
      ></i>
    </div>
  </div>
</div>
